interface IItem {
  id: string
  title: string
}

export default function getItemNameWithId(items: IItem[]) {
  if (!items) return ''
  return items.map((item, index) => `${(item as any)?.[`title_${localStorage.getItem('$flakon$.$uz$language$') as 'en' | 'ru' | 'uz'}`] || item?.title}${index < items.length - 1 ? ' / ' : ''}`).join('');
}